import { useEffect, useState } from "react";
import Table from "../../../../../../../common/components/table"
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { useSelector } from "react-redux";
import Popup from "../../../../../../../common/components/popup";
import { SmsMarketingPlanComponent } from "./sms-marketing-plan.component";
import PageLoader from "../../../../../../../components/PageLoader";
import { deepCopy } from "../../../../../../../common/services/common.service";
import _ from "lodash";
import { selectSmsPlansListItems, selectSmsPlansQueryItems } from "../../../../../../../redux/sms-plans/selector";
import { smsPlans } from "../../../../../../../redux/sms-plans/action";


export const PlanSMSTemplateInfoComponent = ({
  choosenPlan,
  campaignFrequency,
  emailBudget,
  emailNotes,
  customerTags,
  id
}: any) => {


  const dispatch = useAppDispatch();
  const lsitMarketingPlansData = useSelector(selectSmsPlansListItems);
  const querySmsMarketingPlansData = useSelector(selectSmsPlansQueryItems)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [openNewEmailMarketingPlanForm, setOpenNewSmsMarketingPlanForm] = useState<boolean>(false);
  const [openEditEmailMarketingPlanForm, setOpenEditSmsMarketingPlanForm] = useState<boolean>(false);
  const [editPlan, setEditPlan] = useState<boolean>(false);
  const [selectedSmsPlan, setSelectedSmsPlan] = useState<any>({
    "Name": choosenPlan?.Name,
    "MarketingPlanId": choosenPlan?.Id,
    "FrequencyId": choosenPlan?.CampaignFrequencyId,
    "RecipientTagIdInclusions": [],
    "ReplyToEmailInclusions": [],
    "CCTagIdInclusions": [],
    "BCCTagIdInclusions": [],
    "StartDate": choosenPlan?.StartDate,
    "EndDate": choosenPlan?.EndDate
  });


  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', isEdit: true },
      { field: 'FrequencyId', headerName: 'Frequency', },
      { field: 'StartDate', headerName: 'Start Date', isDateValueFormat: true },
      { field: 'EndDate', headerName: 'End Date', isDateValueFormat: true }

    ]);
  }

  const handleInnerEmailFormChange: any = (event: any, field: string) => {
    console.log('choosenSmsPlan123', selectedSmsPlan)
    setSelectedSmsPlan({ ...selectedSmsPlan, [field]: event })
  }


  const additionButtons: any = [
    {
      name: 'Add New SMS Plan',
      callback: () => handleCreateNewSmsPlan(),
    }
  ];


  //#region local functions
  const handleEdit = (data: any) => {
    // setOpenNewSmsMarketingPlanForm(true)
    setEditPlan(true)
    querySmsMarketingPlan(data?.Id)
  }

  const handleDelete = (data: any) => {
      dispatch(smsPlans.delete({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/sms-plans/delete`,
        entity: 'sms',
        jsonData: {
          Records: [
            {
  
              Id: data?.Id
            }
  
          ]
        }
      }));
    }

  const closeModal = () => {
    setOpenNewSmsMarketingPlanForm(false)
    setOpenEditSmsMarketingPlanForm(false)
  }

  const handleSubmit = () => {
    console.log('saving selectedEmailPlan', selectedSmsPlan)
    if (selectedSmsPlan.Id === 0) {
      createSmsMarketingPlan();
    } else {
      updateSmsMarketingPlan();
    }
    lsitSmsMarketingPlans();
    closeModal();
  }

  const handleCreateNewSmsPlan = () => {
    setSelectedSmsPlan({
      "Id": 0,
      "Name": choosenPlan?.Name,
      "MarketingPlanId": choosenPlan?.Id,
      "FrequencyId": choosenPlan?.CampaignFrequencyId,
      "RecipientTagIdInclusions": [],
      "ReplyToEmailInclusions": [],
      "CCTagIdInclusions": [],
      "BCCTagIdInclusions": [],
      "StartDate": choosenPlan?.StartDate,
      "EndDate": choosenPlan?.EndDate
    })
    setOpenNewSmsMarketingPlanForm(true)
  }

  const ShowNewEmailMarketingPlanForm = () => {
    return (
      <>
        <Popup onClose={closeModal}>
          <SmsMarketingPlanComponent
            campaignFrequency={campaignFrequency}
            customerTags={customerTags}
            choosenPlan={choosenPlan}
            choosenSmsPlan={selectedSmsPlan}
            emailBudget={emailBudget}
            emailNotes={emailNotes}
            handleInnerFormChange={handleInnerEmailFormChange}
            closeModal={closeModal}
            handleSubmit={handleSubmit}
          />
        </Popup>
      </>
    )
  }

  const ShowEditEmailMarketingPlanForm = () => {
    return (
      <>
        <Popup onClose={closeModal}>
          <SmsMarketingPlanComponent
            campaignFrequency={campaignFrequency}
            customerTags={customerTags}
            choosenPlan={choosenPlan}
            choosenSmsPlan={selectedSmsPlan}
            emailBudget={emailBudget}
            emailNotes={emailNotes}
            handleInnerFormChange={handleInnerEmailFormChange}
            closeModal={closeModal}
            handleSubmit={handleSubmit}
          />
        </Popup>
      </>
    )
  }


  //#endregion

  //#region API Calls
  const lsitSmsMarketingPlans = () => {
    dispatch(smsPlans.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/sms-plans/list`,
      entity: 'sms',
      jsonData: {

      }
    }))
  }

  const querySmsMarketingPlan = (id: Number) => {
    dispatch(smsPlans.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/sms-plans/query`,
      entity: 'sms',
      jsonData: {
        "Records": [
          {
            "Id": id
          }
        ]
      }
    }))
  }

  const createSmsMarketingPlan = async () => {
    const emailPlan = deepCopy(selectedSmsPlan)
    emailPlan["ReplyToEmailInclusions"] = _.isArray(selectedSmsPlan?.ReplyToEmailInclusions) ? selectedSmsPlan?.ReplyToEmailInclusions : [selectedSmsPlan?.ReplyToEmailInclusions] //array of strings
    await dispatch(smsPlans.resetAction({ actionType: 'create' }))
    await dispatch(smsPlans.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/sms-plans`,
      entity: 'sms',
      jsonData: {
        "Records": [
          emailPlan
        ]
      }
    }))
    lsitSmsMarketingPlans()
  }

  const updateSmsMarketingPlan = async () => {
    const emailPlan = deepCopy(selectedSmsPlan)
    emailPlan["ReplyToEmailInclusions"] = _.isArray(selectedSmsPlan?.ReplyToEmailInclusions) ? selectedSmsPlan?.ReplyToEmailInclusions : [selectedSmsPlan?.ReplyToEmailInclusions] //array of strings
    await dispatch(smsPlans.resetAction({ actionType: 'update' }))
    await dispatch(smsPlans.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/sms-plans`,
      entity: 'sms',
      jsonData: {
        "Records": [
          emailPlan
        ]
      }
    }))
  }
  //#endregion

  //#region     
  useEffect(() => {
    if (editPlan && querySmsMarketingPlansData?.result?.items) {
      setSelectedSmsPlan(querySmsMarketingPlansData?.result?.items)
      setOpenEditSmsMarketingPlanForm(true)
    } else {
      setSelectedSmsPlan({
        "Id": 0,

        "Name": choosenPlan?.Name,
        "MarketingPlanId": choosenPlan?.Id,
        "FrequencyId": choosenPlan?.CampaignFrequencyId,
        "RecipientTagIdInclusions": [],
        "ReplyToEmailInclusions": [],
        "CCTagIdInclusions": [],
        "BCCTagIdInclusions": [],
        "StartDate": choosenPlan?.StartDate,
        "EndDate": choosenPlan?.EndDate
      })
    }
  }, [querySmsMarketingPlansData]);

  useEffect(() => {
    createColumnDefs();
    lsitSmsMarketingPlans();
  }, []);
  //#endregion
console.log("SMS Plans Data:", lsitMarketingPlansData?.result?.items);

  return (
    <>
      {lsitMarketingPlansData?.isLoading && <PageLoader />}
      {lsitMarketingPlansData && <Table
        columnData={columnDefs}
   rowData={lsitMarketingPlansData?.result?.items}
        setPageData={setPageData}
        setPageSize={setPageSize}
        paginationData={lsitMarketingPlansData?.result?.pagination}
        onEdit={handleEdit}
        onDelete={handleDelete}
        additionButtons={additionButtons}
        headingName="Marketing SMS Plan" />}

      {openNewEmailMarketingPlanForm && <ShowNewEmailMarketingPlanForm />}
      {openEditEmailMarketingPlanForm && <ShowEditEmailMarketingPlanForm />}
    </>
  )
}